import React from 'react';
import PropTypes from 'prop-types';
import AppLinks from 'components/AppLinks';
import { connect } from 'react-redux';

import NewPassword from './NewPassword';


const Settings = ({ valuesByKey }) => (
  <div style={{ paddingBottom: 8 }}>
    {(!valuesByKey['Hide.Settings.NewPassword'] || valuesByKey['Hide.Settings.NewPassword'].Value !== 'true') && <NewPassword />}
    {(!valuesByKey['Hide.Settings.AppLinks'] || valuesByKey['Hide.Settings.AppLinks'].Value !== 'true') && <AppLinks />}
  </div>
);

Settings.propTypes = {
  valuesByKey: PropTypes.object,
};

export default connect(state => ({ valuesByKey: state.WebValuesReducer.valuesByKey }))(Settings);



// WEBPACK FOOTER //
// ./src/containers/Settings.js